import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Button } from '@/atoms';
import { bold, book, colors } from '@/styles';

function VideoUploadError({ className, errorMessage, layout, onDismiss }) {
  return (
    <div className={className}>
      <div className="video-too-large-message">
        <h1>Upload Error</h1>
        {errorMessage.includes('too large') ? (
          <div>
            <p>The video you have chosen is too large to upload at this time</p>
            <p>Please choose a smaller video to ensure the upload occurs in a timely manner</p>
          </div>
        ) : (
          <div>
            <p>There was an issue with your video</p>
            <p>{errorMessage}</p>
          </div>
        )}
        <Button size="xlarge" color={colors.taosSky} label="Okay" onClick={onDismiss} />
      </div>
    </div>
  );
}

VideoUploadError.propTypes = {
  className: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  layout: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default styled(VideoUploadError)`
  position: absolute;
  z-index: 100;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.boxShadowDark};

  .video-too-large-message {
    ${(props) => (props.layout === 'compact' ? '' : 'height: 75%;')}
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 5%;
    background-color: ${colors.white};
    border-radius: 2%;

    h1 {
      ${bold()}
      color: ${colors.shadow};
      font-size: 2rem;
    }

    p {
      ${book()}
      color: ${colors.shadow};
      text-align: center;
    }

    button {
      padding: 0 25%;
      margin: 5%;
    }
  }
`;
